import { CategoryModel } from '../../category/models/CategoryModel'

export class ProductCategoryChannelModel {
    id?:string|number = undefined
    idProduct?:string|number = undefined
    idCategory?:string|number = undefined
    idChannel?:string|number = undefined
    category?:CategoryModel = undefined

    constructor(p?:Partial<ProductCategoryChannelModel>) {
        Object.assign(this, p)

        this._parseCategory()
    }

    private _parseCategory():void {
        this.category = new CategoryModel(this.category)
    }
}
